"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectionBoundingClientRect = void 0;
var _createVirtualElement = require("../createVirtualElement");
/** Get bounding client rect of the window selection */
var getSelectionBoundingClientRect = function getSelectionBoundingClientRect() {
  var domSelection = window.getSelection();
  if (!domSelection || domSelection.rangeCount < 1) {
    return (0, _createVirtualElement.getDefaultBoundingClientRect)();
  }
  var domRange = domSelection.getRangeAt(0);
  return domRange.getBoundingClientRect();
};
exports.getSelectionBoundingClientRect = getSelectionBoundingClientRect;